/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const PlusIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M12 3.5a1 1 0 0 1 1 1V11h6.5a1 1 0 1 1 0 2H13v6.5a1 1 0 1 1-2 0V13H4.5a1 1 0 1 1 0-2H11V4.5a1 1 0 0 1 1-1" clipRule="evenodd" /></svg>;
};
export default PlusIcon;